import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { VaExpandDirective } from './va-expand.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [VaExpandDirective],
  exports: [VaExpandDirective],
})
export class VaExpandModule {}
